import {reactive, watch} from "vue";

const sessionName = 'page';

const loadSession = () => {
    let s = sessionStorage.getItem(sessionName);
    if (s) {
        return JSON.parse(s);
    } else {
        sessionStorage.setItem(sessionName, '{}');
        return {};
    }
}

const session = reactive(loadSession());

watch(session,(newValue) => {
    sessionStorage.setItem(sessionName, JSON.stringify(newValue));
})

const useSession = (ns, defaultValue = {}) => {
    if (session[ns] === undefined) {
        session[ns] = defaultValue;
    }
    return session[ns];
}

export default useSession;
export {
    useSession
}
